// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const isAppInForeground = () => true;

export { isAppInForeground };
//# sourceMappingURL=isAppInForeground.mjs.map
